import {isPlatformBrowser} from '@angular/common';
import {Inject, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {ActionTypeStrategy, TransactionListCta} from '@dcp/configurator';

export class NavigationActionTypeStrategy implements ActionTypeStrategy {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private cta: TransactionListCta,
    private router: Router,
  ) {
  }

  public action(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.cta?.targetUrl) {
        throw new Error('Target url is missing');
      }
      const url = new URL(this.cta.targetUrl);
      if([undefined, null, ''].some((elem) => elem === url.searchParams.get('back'))) {
        url.searchParams.set('back', '1');
      }
      if (this.cta.targetUrl.startsWith(window.location.origin)) {
        if (window.location.href?.includes('/configurator')) {
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigateByUrl(url.href.replace(url.origin, ''));
          });
        } else {
          this.router.navigateByUrl(url.href.replace(url.origin, ''));
        }
      } else {
        window.open(url.href, '_self');
      }
    }
  }
}
